import { gql } from 'urql';

const GetAdvanceReEligibilityDetails = gql`
  query FetchAdvanceReEligibility($id: ID!) {
    accountR2(id: $id) {
      id
      product
      __typename
      ... on InternalAdvanceAccount {
        id
        reEligiblityDetail {
          description
          descriptionHtml
          title
          articleLink {
            articleId
          }
        }
      }
    }
  }
`;

export default GetAdvanceReEligibilityDetails;
